export default __webpack_public_path__ + "static/media/aw.81ee4363.svg";